import type {AxiosError} from 'axios'
import type {ReactNode} from 'react'

import {MutationError} from './interfaces/api'

type RaiseError = (error: Error | null) => void
type NotifyError = (message: ReactNode) => void

export const notifyIfErrorMessage = (
  data: unknown,
  raiseError: RaiseError,
  notifyError: NotifyError
): void => {
  if (typeof data === 'string') notifyError(data)
  else if (data) raiseError(new Error(JSON.stringify(data)))
  // TODO: Add generic error message when no data.
}

export const handleConfigurationError = <T>(
  error: AxiosError<MutationError<T>>,
  raiseError: RaiseError,
  notifyError: NotifyError
): void => {
  const errorData = error.response?.data
  const errorMessage = typeof errorData === 'string' ? errorData : errorData?.detail
  if (!errorMessage) {
    raiseError(error)
    return
  }
  // handle overall message
  notifyIfErrorMessage(errorMessage, raiseError, notifyError)
}
